<footer class="footer">
  <span class="title-footer" [ngClass]="{
  'absolute': setAbsoluteProperty,
  'pharmacies-title-footer' : isPharmaciesPage && screen.isMobile(),
  'search-page-mobile': isSearchPage && screen.isMobile()
}" [textContent]="'footer.global.title' | transloco"></span>
  <div [ngStyle]="{
  'padding-top': setAbsoluteProperty && screen.isMobile() && i === 1 ? '65px' : '0px'
}" [ngClass]="{
  'pharmacies-page' : isPharmaciesPage
}" class="row" *ngFor="let item of dataStatic, let i = index">
    <ng-container *ngFor="let el of item.elem">
      <div class="footer-element" [ngStyle]="{
      'min-height' : isPharmaciesPage ? 'auto' : '',
      'display': i === 0 && isPharmaciesPage ? 'none' : ''
    }" *ngIf="el.text.length > 0" [ngClass]="{'bordred': i === 0}">
        <p class="title" [ngStyle]="{
        'color' : el.color,
        'padding': el.img ? '15px 0 15px 60px' : '15px 0 15px 3px'
      }">
          {{el.title | transloco}}
          <img *ngIf="el.img" [src]="'../../../../../assets/' + el.img" [alt]="el.title">
        </p>
        <ng-container *ngIf="!el.isEmpty else appButtons">
          <p *ngIf="!arr.isArray(el.text) else arrText" class="body" [textContent]="el.text | transloco"></p>
        </ng-container>
        <ng-template #arrText>
          <ng-container *ngIf="!el.isButtons else appButtons">
            <a [routerLink]="goToPage(item)" class="links" *ngFor="let item of el.text"
              [textContent]="item | transloco"></a>
          </ng-container>
        </ng-template>
        <ng-template #appButtons>
          <div class="app-buttons" [class.buttons-in-phrmacies-page]="isPharmaciesPage">
            <a rel="nofollow" href="https://play.google.com/store/apps/details?id=ua.com.llc.zdorovi" target="_blank"
              class="platform">
              <img class="platform-icon" src="../../../assets/icons/play-market-icon.svg" alt="google-play-icon"
                title="Google Play">
              <p class="platform-text">Google Play</p>
            </a>
            <a rel="nofollow" href="https://apps.apple.com/ua/app/zdorovi-ua-пошук-ліків/id1591178876?platform=iphone"
              target="_blank" class="platform">
              <img class="platform-icon" src="../../../assets/icons/app-store-icon.svg" alt="app-store-icon"
                title="App Store">
              <p class="platform-text">App Store</p>
            </a>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="showCopyright">
    <div class="footer-copyright">
      <span>2021-2024&nbsp;Zdorovi.ua&nbsp;&copy;</span>
    </div>
    <div class="row-margin"></div>
  </ng-container>
</footer>